import { useQuery } from '@tanstack/react-query';

import { personasQuery } from '../api/persona.api';

/**
 * Fetches all personas for a given workspace.
 *
 * @param workspaceId - The workspace to fetch personas for
 * @param enabled     - Whether the query should be enabled (default: true)
 */
export const usePersonas = (workspaceId: string | null | undefined, enabled = true) => {
  return useQuery({
    ...personasQuery(workspaceId),
    enabled: enabled && !!workspaceId,
  });
};
